
  export default {
    middleware: ['products/cover-types', 'providers', 'jumbotron', 'breadcrumbs', 'meta-tags'],
    meta: {
      breadcrumbs: [['i18n/home', '/'], ['i18n/insurance', '/insurance/'], 'i18n/providers'],
      jumbotronLifeScope: 'providers',
      metaTagOptions: { image: 'insurance' },
      product: 'life-insurance'
    },
    computed: {
      coverType () {
        return this.$store.getters['products/getCoverType'];
      }
    }
  };
